import React from 'react';
import { BookCover } from './BookCover';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-club px-5 py-20 md:py-28" aria-labelledby="bonus-title" data-id="element-14" data-mp="pioa4qcb3aan">
      <div className="mx-auto max-w-6xl" data-id="element-15" data-mp="au1usomoiijf">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-16" data-mp="asz3iflg2e2z">
          <h2 id="bonus-title" className="font-display text-4xl uppercase leading-none text-cream md:text-6xl" data-id="element-17" data-mp="fsbrx4ryrt7o">
            + 5 bonus <span className="text-gold" data-id="element-18" data-mp="1wrg0tankb9r">exclusifs</span>
          </h2>
          <p className="max-w-md font-serif text-lg italic text-cream/80" data-id="element-19" data-mp="5xjpnnnfsi6k">
            Inclus gratuitement si vous commandez aujourd’hui, avant la fin du compte à rebours.
          </p>
        </div>

        <ol className="mt-10 space-y-6 sm:mt-16" data-id="element-20" data-mp="3t0yc046126z8">
          {bonuses.map((b, i) => <li key={b.name} className="grid grid-cols-[88px_1fr] items-center gap-x-4 gap-y-3 border-t border-gold/25 pt-6 sm:grid-cols-[140px_1fr] sm:gap-6 md:grid-cols-[160px_1fr_auto] md:gap-10" data-id="element-21" data-mp="1mbjmuquwdtq4" data-mpi={i}>
              <BookCover {...b} className="w-full text-[8px] sm:text-sm" data-id="element-22" data-mp="3dfd2vkijy2te" />
              <div data-id="element-23" data-mp="3df3dnz5bzzor">
                <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gold sm:text-xs sm:tracking-[0.2em]" data-id="element-24" data-mp="3r6qk2rszmol9">
                  Bonus {String(i + 1).padStart(2, '0')} · {b.pages}
                </p>
                <h3 className="mt-1.5 font-serif text-lg font-semibold leading-snug text-cream sm:mt-2 sm:text-2xl md:text-3xl" data-id="element-25" data-mp="2zfals0i2jdf7">
                  {b.name}
                </h3>
                <p className="mt-1.5 text-sm text-cream/60 md:hidden" data-id="element-26" data-mp="2uiu1jhdzpj7e">
                  <s data-id="element-27" data-mp="38htlwcugzbxr">{b.value} $</s> <span className="font-semibold text-gold-soft" data-id="element-28" data-mp="38e5ubj8l4zlo">Offert</span>
                </p>
                <p className="mt-3 hidden max-w-2xl leading-relaxed text-cream/70 sm:block" data-id="element-29" data-mp="33ja3gmf34ia5">{b.description}</p>
              </div>
              <p className="col-span-2 text-[15px] leading-relaxed text-cream/70 sm:hidden" data-id="element-30" data-mp="ir6sdx7yte8b">{b.description}</p>
              <p className="hidden text-sm text-cream/60 md:block md:text-right" data-id="element-31" data-mp="3cjg1bk8fb3mm">
                <s data-id="element-32" data-mp="3hhr79jvlktzk">{b.value} $</s>
                <span className="block font-display text-3xl text-gold-soft" data-id="element-33" data-mp="3hgybtf239qwq">Offert</span>
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}